/* eslint-disable no-return-await */
/* eslint-disable func-names */
import object from "lodash/object";
import { toastr } from "react-redux-toastr";
import { getAccessToken } from "../../utils/tokens";
import communicationTriggers from "../../utils/communicationTriggers";
import { fetchRequest } from "../../utils/http.ts";
import { fullAPIURL } from "../../utils/requests";
import { logError } from "../../components/Errors";

export const FETCH_TRIGGERS = "FETCH_TRIGGERS";
export const SET_TRIGGERS = "SET_TRIGGERS";
export const COMMUNICATIONS_ERROR = "COMMUNICATIONS_ERROR";
export const UPDATE_TRIGGER = "UPDATE_TRIGGER";
export const UPDATE_TRIGGER_BULK = "UPDATE_TRIGGER_BULK";
export const FETCH_WORKFLOW = "FETCH_WORKFLOW";
export const UPDATE_WORKFLOW = "UPDATE_WORKFLOW";
export const SET_WORKFLOW = "SET_WORKFLOW";
export const FETCH_COACHES = "FETCH_COACHES";
export const FETCH_ADMINS = "FETCH_ADMINS";
export const SEARCH_PERSONS = "SEARCH_PERSONS";
export const SET_ACTIVE_WORKFLOW_ID = "SET_ACTIVE_WORKFLOW_ID";
export const SET_SIDE_PANEL = "SET_SIDE_PANEL";
export const SAVE_WORKFLOW = "SAVE_WORKFLOW";
export const RESET_WORKFLOW_DEFAULT = "RESET_WORKFLOW_DEFAULT";
export const SET_ACTIVE_WORKFLOW_ERRORS = "SET_ACTIVE_WORKFLOW_ERRORS";

function makeid(length) {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function setCommunicationError(error) {
  return async function (dispatch, getState) {
    const state = getState();

    const { data: user } = state.user;

    const { data: client } = state.client;

    logError({
      client: object.get(client, "uuid"),
      user: {
        id: object.get(user, "user_uuid"),
        name: `${object.get(user, "first_name")} ${object.get(
          user,
          "last_name",
        )}`,
      },
      message: error,
      severity: "error",
      feature: COMMUNICATIONS_ERROR,
    });

    toastr.warning("Error", "An error occured. Please try again later.");

    return Promise.resolve();
  };
}

export function setSidePanelAction(value) {
  return {
    type: SET_SIDE_PANEL,
    showSidePanel: value,
  };
}

export function setTriggers(triggers) {
  return {
    type: SET_TRIGGERS,
    triggers,
  };
}

export function setActiveWorkflowAction(activeWorkflowId) {
  return {
    type: SET_ACTIVE_WORKFLOW_ID,
    activeWorkflowId,
  };
}

export function setActiveWorkflowErrorsAction(errors) {
  return {
    type: SET_ACTIVE_WORKFLOW_ERRORS,
    errors,
  };
}

export function setWorkflow(workflow, event) {
  return {
    type: SET_WORKFLOW,
    workflow,
    event,
  };
}

export function setActiveWorkFlow(workflowId) {
  return function (dispatch, getState) {
    const {
      workflows: { activeWorkflowId },
    } = getState();

    if (workflowId !== activeWorkflowId) {
      return dispatch(setActiveWorkflowAction(workflowId));
    }
  };
}

export function setSidePanel(value) {
  return function (dispatch, getState) {
    const {
      workflows: { showSidePanel },
    } = getState();

    if (showSidePanel !== value) {
      return dispatch(setSidePanelAction(value));
    }
  };
}

export function fetchTriggers() {
  return async function (dispatch, getState) {
    const token = getAccessToken();

    let response = null;

    const state = getState();

    const { data: client } = state.client;

    try {
      response = await fetchRequest({
        method: "GET",
        path: `${fullAPIURL}/v2/client/client/${object.get(
          client,
          "uuid",
        )}/setting?type=communications`,
        options: {
          token,
          headers: { "Content-Type": "application/json" },
        },
      });

      if (response && response.ok) {
        const communicationsEvents = await response.json();

        const communicationsTableData = communicationTriggers.map((trigger) => {
          const event = communicationsEvents.data.find(
            (e) => e.name === trigger.eventName,
          );

          if (event) {
            return {
              ...trigger,
              id: event.id,
              status: event.value === "1" ? "ACTIVE" : "INACTIVE",
            };
          }

          return trigger;
        });

        return dispatch(setTriggers(communicationsTableData));
      }
      return dispatch(setCommunicationError(new Error("Response Failed")));
    } catch (error) {
      console.error({ error });
      return dispatch(setCommunicationError(error));
    }
  };
}

export function updateTrigger(payload) {
  return async function (dispatch, getState) {
    const token = getAccessToken();

    const state = getState();

    const { data: client } = state.client;
    const { data: communicationsData } = state.communications;

    const updatedCommunicationsData = communicationsData.map((datum) => {
      if (datum.id === payload.id) {
        return {
          ...datum,
          status: payload.status,
        };
      }

      return datum;
    });

    dispatch(setTriggers(updatedCommunicationsData));

    try {
      return await fetchRequest({
        method: "PUT",
        path: `${fullAPIURL}/v2/client/client/${object.get(
          client,
          "uuid",
        )}/setting/${payload.id}`,
        body: {
          ...payload,
          value: payload.status === "INACTIVE" ? "0" : "1",
        },
        options: {
          token,
          headers: { "Content-Type": "application/json" },
        },
      });
    } catch (error) {
      console.error({ error });
      return dispatch(setCommunicationError(error));
    }
  };
}

export function updateTriggerBulk(payload) {
  return async function (dispatch, getState) {
    const state = getState();
    const token = getAccessToken();

    const { data: client } = state.client;

    try {
      const updates = payload.ids.map(async (id) => {
        return await fetchRequest({
          method: "PUT",
          path: `${fullAPIURL}/v2/client/client/${object.get(
            client,
            "uuid",
          )}/setting/${id}`,
          body: {
            id,
            value: payload.value,
          },
          options: {
            token,
            headers: { "Content-Type": "application/json" },
          },
        });
      });

      await Promise.all(updates);

      return dispatch(fetchTriggers());
    } catch (error) {
      console.error({ error });
      return dispatch(setCommunicationError(error));
    }
  };
}

export function fetchWorkflow(event) {
  return async function (dispatch, getState) {
    const token = getAccessToken();

    let response = null;

    const state = getState();

    const { data: client } = state.client;

    try {
      response = await fetchRequest({
        method: "GET",
        path: `${fullAPIURL}/v2/communications/${object.get(
          client,
          "uuid",
        )}/trigger/${event}/communications`,
        options: {
          token,
          headers: { "Content-Type": "application/json" },
        },
      });

      if (response && response.ok) {
        const result = await response.json();

        const workflowId = result.data[0].blocks[0].id;

        dispatch(setActiveWorkflowAction(workflowId));

        return dispatch(setWorkflow(result.data[0], event, true));
      }
    } catch (error) {
      console.error({ error });
      return dispatch(setCommunicationError(error));
    }
  };
}

export function canSaveWorkflow(event, workflowId) {
  return function (dispatch, getState) {
    const { workflows } = getState();

    const workflow = workflows[event];

    const activeBlock = workflow.blocks.find(
      (block) => block.id === workflowId,
    );

    if (!activeBlock) {
      dispatch(setCommunicationError("Active Workflow block not found"));

      return false;
    }

    const errors = {};

    const values = Object.values(activeBlock);

    const keys = Object.keys(activeBlock);

    values.map((val, index) => {
      if (val === "" || (Array.isArray(val) && !val.length)) {
        const key = keys[index];

        errors[key] = "Required!";
      }
    });

    if (Object.keys(errors).length) {
      dispatch(setActiveWorkflowErrorsAction(errors));

      return false;
    }

    return true;
  };
}

export function addWorkflowStep(event) {
  return async function (dispatch, getState) {
    const state = getState();

    const { workflows } = state;
    const { data: client } = state.client;

    const workflow = workflows[event];

    const block = {
      id: `workflow_${makeid(15)}`,
      type: "EMAIL",
      to: [{ id: "ADMINS", name: "ADMINS" }],
      subject: "",
      replyToEmail: client.email,
      replyToName: client.company,
      content: "",
      canDelete: true,
    };

    workflow.blocks.push(block);

    dispatch(setWorkflow(workflow, event, "add-workflow-step"));
  };
}

export function patchWorkflowStep(event, blockId, patch) {
  return function (dispatch, getState) {
    const state = getState();

    const { workflows } = state;

    const workflow = workflows[event];

    const block = workflow.blocks.find((b) => b.id === blockId);
    const blockIndex = workflow.blocks.findIndex((b) => b.id === blockId);

    if (!block) {
      return dispatch(setCommunicationError("Workflow block not found"));
    }

    workflow.blocks[blockIndex] = { ...block, ...patch };

    return dispatch(setWorkflow(workflow, event, "patch-workflow-step"));
  };
}

export function saveWorkflow(event) {
  return async function (dispatch, getState) {
    const state = getState();
    const token = getAccessToken();

    const { workflows } = state;
    const { data: client } = state.client;

    const workflow = workflows[event];

    let isValid = true;

    workflow.blocks.map((block) => {
      const values = Object.values(block);

      if (
        values.some((val) => val === "" || (Array.isArray(val) && !val.length))
      ) {
        isValid = false;
      }
    });

    if (!isValid) {
      return dispatch(
        setCommunicationError("Required fields are empty in workflow"),
      );
    }

    try {
      await fetchRequest({
        method: "PATCH",
        path: `${fullAPIURL}/v2/communications/${object.get(
          client,
          "uuid",
        )}/trigger/${event}/communications`,
        body: {
          ...workflow,
        },
        options: {
          token,
          headers: { "Content-Type": "application/json" },
        },
      });

      return toastr.success("Successfully updated workflow");
    } catch (error) {
      console.error({ error });
      return dispatch(setCommunicationError(error));
    }
  };
}

export function resetDefault(event, blockId) {
  return async function (dispatch, getState) {
    const state = getState();
    const token = getAccessToken();

    const { workflows } = state;
    const { data: client } = state.client;

    let response = null;

    const workflow = workflows[event];

    const block = workflow.blocks.find((b) => b.id === blockId);

    if (!block) {
      return dispatch(setCommunicationError("Workflow block not found"));
    }

    const blockIndex = workflow.blocks.findIndex((b) => b.id === blockId);
    const isMemberBlock = blockIndex === 0;

    const sendContext =
      isMemberBlock &&
      ["user.lead.created", "subscription.migration.confirmed"].includes(event);

    const context = `MEMBER`;

    try {
      response = await fetchRequest({
        method: "GET",
        path: `${fullAPIURL}/v2/communications/${object.get(
          client,
          "uuid",
        )}/templates/${event}?context=${sendContext ? context : ""}`,
        options: {
          token,
          headers: { "Content-Type": "application/json" },
        },
      });

      if (response && response.ok) {
        const result = await response.json();

        const { template, subject } = result;

        workflow.blocks[blockIndex] = { ...block, content: template, subject };

        dispatch(setWorkflow(workflow, event, "patch-workflow-step"));

        const action = saveWorkflow(event);

        await action(dispatch, getState);

        return toastr.success("Email Reset");
      }
    } catch (error) {
      console.error({ error });
      return dispatch(setCommunicationError(error));
    }
  };
}

export function deleteWorkflowStep(event, workflowId) {
  return async function (dispatch, getState) {
    const state = getState();
    const token = getAccessToken();

    const { workflows } = state;
    const { data: client } = state.client;

    const workflow = workflows[event];

    workflow.blocks = workflow.blocks.filter(
      (block) => block.id !== workflowId,
    );

    dispatch(setWorkflow(workflow, event, "delete-workflow-step"));

    const activeWorkflowId = workflow.blocks[0].id;

    dispatch(setActiveWorkflowAction(activeWorkflowId));

    try {
      return await fetchRequest({
        method: "PATCH",
        path: `${fullAPIURL}/v2/communications/${object.get(
          client,
          "uuid",
        )}/trigger/${event}/communications`,
        body: {
          ...workflow,
        },
        options: {
          token,
          headers: { "Content-Type": "application/json" },
        },
      });
    } catch (error) {
      console.error({ error });
      return dispatch(setCommunicationError(error));
    }
  };
}

export function setAdmins(admins) {
  return {
    type: FETCH_ADMINS,
    admins,
  };
}

export function setCoaches(coaches) {
  return {
    type: FETCH_COACHES,
    coaches,
  };
}

export function setSuggestedPersons(persons) {
  return {
    type: SEARCH_PERSONS,
    persons,
  };
}

export function searchPersons(param, term = "search") {
  let searchTerm = "search";

  if (term === "name" || term === "email" || term === "search") {
    searchTerm = term;
  }

  return async function (dispatch, getState) {
    const state = getState();
    const token = getAccessToken();

    const { data: client } = state.client;

    try {
      const response = await fetchRequest({
        method: "GET",
        path: `${fullAPIURL}/v2/client/client/${object.get(
          client,
          "uuid",
        )}/persons?${searchTerm}=${param}`,
        options: {
          token,
          headers: { "Content-Type": "application/json" },
        },
      });
      if (response && response.ok) {
        const result = await response.json();

        console.log("SUGGESTED_SEARCH", result);

        if (result.wasSuccessful && result.data) {
          return dispatch(
            setSuggestedPersons(
              result.data.map((person) => {
                const fullName = `${person.firstName} ${person.lastName}`;
                return {
                  id: person.userId,
                  uuid: person.uuid,
                  name: fullName,
                  value: fullName,
                  label: fullName,
                  email: person.email,
                  role: person.role,
                };
              }),
            ),
          );
        }
      }
    } catch (error) {
      console.error({ error });
      return dispatch(setCommunicationError(error));
    }
  };
}

export function fetchAdmins() {
  return async function (dispatch, getState) {
    const state = getState();
    const token = getAccessToken();

    const { data: client } = state.client;

    try {
      const response = await fetchRequest({
        method: "GET",
        path: `${fullAPIURL}/v2/client/client/${object.get(
          client,
          "uuid",
        )}/admins`,
        options: {
          token,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      });
      if (response && response.ok) {
        const result = await response.json();

        return dispatch(
          setAdmins(
            result.data.map((admin) => {
              const fullName = `${admin.firstName} ${admin.lastName}`;
              return {
                id: admin.userId,
                uuid: admin.uuid,
                name: fullName,
                value: fullName,
                label: fullName,
                email: admin.email,
                role: admin.role || "admin",
              };
            }),
          ),
        );
      }
    } catch (error) {
      console.error({ error });
      return dispatch(setCommunicationError(error));
    }
  };
}

export function fetchCoaches() {
  return async function (dispatch, getState) {
    const state = getState();
    const token = getAccessToken();

    const { data: client } = state.client;

    try {
      const response = await fetchRequest({
        method: "GET",
        path: `${fullAPIURL}/v2/client/client/${object.get(
          client,
          "uuid",
        )}/coaches`,
        options: {
          token,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      });
      if (response && response.ok) {
        const result = await response.json();

        return dispatch(
          setCoaches(
            result.data.map((coach) => {
              const fullName = `${coach.firstName} ${coach.lastName}`;
              return {
                id: coach.userId,
                uuid: coach.uuid,
                name: fullName,
                value: fullName,
                label: fullName,
                email: coach.email,
                role: coach.role || "coach",
              };
            }),
          ),
        );
      }
    } catch (error) {
      console.error({ error });
      return dispatch(setCommunicationError(error));
    }
  };
}
